import { MessageCircle, FileCheck, Plane, HeartPulse } from "lucide-react";

const steps = [
  {
    icon: MessageCircle,
    number: "01",
    title: "Share Your Needs",
    description: "Chat with our AI assistant or speak to a care coordinator. We understand your treatment requirements.",
  },
  {
    icon: FileCheck,
    number: "02",
    title: "Get Your Plan",
    description: "Receive a personalized treatment plan with cost estimates, hospital options, and doctor profiles.",
  },
  {
    icon: Plane,
    number: "03",
    title: "Travel to India",
    description: "We handle visa assistance, airport pickup, hotel booking, and all logistics for your medical journey.",
  },
  {
    icon: HeartPulse,
    number: "04",
    title: "Receive Care",
    description: "Get world-class treatment with a dedicated coordinator by your side. Return home with follow-up support.",
  },
];

export function HowItWorksSection() {
  return (
    <section className="py-16 lg:py-24 bg-muted">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-12 lg:mb-16">
          <span className="inline-block text-primary font-medium text-sm uppercase tracking-wider mb-4">
            Simple Process
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-secondary mb-4">
            How TrustedHeal Works
          </h2>
          <p className="text-foreground/70 text-lg">
            From first inquiry to returning home healthy — we're with you every step of the way.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {steps.map((step, index) => (
            <div key={step.title} className="relative group">
              {/* Connector Line - Desktop */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-[55%] w-[90%] h-px bg-gradient-to-r from-primary/40 to-primary/10" />
              )}

              <div className="relative bg-card rounded-2xl p-6 lg:p-8 shadow-soft border border-border/50 text-center transition-all duration-300 hover:shadow-hover hover:-translate-y-1 hover:border-primary/20">
                {/* Step Number */}
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-9 h-9 rounded-full bg-primary text-primary-foreground font-display font-bold text-sm flex items-center justify-center shadow-md transition-transform duration-300 group-hover:scale-110">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mx-auto mb-5 mt-4 transition-colors duration-300 group-hover:bg-primary/15">
                  <step.icon className="w-7 h-7 text-primary" />
                </div>

                {/* Content */}
                <h3 className="font-display text-lg font-semibold text-secondary mb-2 transition-colors duration-300 group-hover:text-primary">
                  {step.title}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
